export default {
    link: 'chakras-guide',
    name: 'Guia de Chakras',
    title: 'Guia de Chakras',

    paywallOTS: {
        hero: {
            alt: 'Ilustração introdutória do Guia de Chakras'
        },

        availableNow: 'Disponível agora — Acesso imediato',

        greeting: 'Olá, {name}! <b>O Guia de Chakras</b> chegou!',

        title1: 'Um conteúdo feito para você equilibrar sua energia pessoal e usá-la a seu favor sempre que precisar.',

        cta1: 'Eu quero',

        recognitionLabel: 'Reconhecimento',
        recognitionTitle: 'Você se reconhece em algum desses padrões?',
        recognitionSubtitle: 'São situações que parecem diferentes por fora, mas têm a mesma raiz por dentro.',

        patternCards: {
            0: {
                title: 'Relações que mudam de rosto, mas mantêm a mesma dinâmica',
                text: 'Parceiros, amizades, dinâmicas de trabalho. Os nomes mudam, mas a sensação familiar nunca vai embora.'
            },
            1: {
                title: 'Decisões que prometem libertação, mas conduzem ao mesmo ponto',
                text: 'Você muda de direção com determinação. Mas de alguma forma chega de volta ao mesmo lugar.'
            },
            2: {
                title: 'Cansaço, insegurança ou irritação que não desaparecem com esforço',
                text: 'Não é falta de vontade. É algo operando em uma camada que o esforço consciente não alcança.'
            }
        },

        grayCard: 'Em geral, as pessoas só começam a se interessar por autoconhecimento quando percebem que algo está se repetindo - não necessariamente um grande problema, mas padrões que voltam com nomes diferentes e que são limitadores.',

        excessInfo: {
            title: 'O problema não é falta de informação. Na verdade, às vezes, é o excesso.',
            bullets: {
                0: 'A mente acelera sem parar',
                1: 'O corpo acompanha o ritmo acelerado',
                2: 'As emoções tentam se adaptar'
            },
            paragraph1: 'Vivemos em um mundo que oferece acesso a quase tudo: técnicas, conceitos, opiniões... mas a maior parte dessas ferramentas pressupõe que você já possui uma compreensão clara da sua própria estrutura interna.',
            paragraph2: 'O problema é que a maioria de nós não tem. Não por negligência, mas porque nunca fomos ensinados a perceber nossa própria organização energética.',
            paragraph3: 'O conhecimento dos chakras surgiu justamente como uma tentativa antiga (e surpreendentemente atual) de mapear essa organização interna que perdemos de vista.',
            cta: 'Mapear minhas emoções'
        },

        sevenCentersLabel: 'Os sete centros',
        sevenCentersTitle: 'O que são chakras: sem o misticismo, com toda a profundidade',
        sevenCentersText: 'De acordo com a filosofia oriental, os chakras são centros energéticos que organizam diferentes aspectos da nossa experiência. Cada um está ligado a áreas específicas da vida — do físico ao sutil, da sobrevivência ao propósito.',

        chakras: {
            0: { name: 'MULADHARA', description: 'Segurança e pertencimento' },
            1: { name: 'SVADHISTHANA', description: 'Vínculos e criatividade' },
            2: { name: 'MANIPURA', description: 'Poder pessoal e autoestima' },
            3: { name: 'ANAHATA', description: 'Amor e conexão profunda' },
            4: { name: 'VISHUDDHA', description: 'Expressão e comunicação autêntica' },
            5: { name: 'AJNA', description: 'Intuição e clareza interior' },
            6: { name: 'SAHASRARA', description: 'Propósito e consciência' }
        },

        chakrasAuxCard: 'Quando esses centros funcionam de maneira equilibrada, nossas decisões tendem a ser mais conscientes. Quando estão em desequilíbrio, aparecem exageros, bloqueios ou compensações que moldam nossas escolhas sem que percebamos.',

        noPromisesLabel: 'Sem promessas vazias',
        noPromisesTitle: 'O que o trabalho com chakras não promete e o que realmente entrega',

        myths: {
            title: 'Mitos',
            items: {
                0: 'Um botão de "agora tudo foi resolvido na minha vida"',
                1: 'Ativar algo extraordinário ou mágico',
                2: 'Uma promessa de eliminar seus desafios',
                3: 'Uma solução rápida que prescinde de autoconhecimento'
            }
        },

        truths: {
            title: 'Verdades',
            items: {
                0: 'Saber identificar onde existe excesso e onde existe carência no momento',
                1: 'Reconhecer quando não é falta de força, mas força mal direcionada',
                2: 'Perceber quando não é ausência de voz, mas uso inadequado dela',
                3: 'Distinguir quando não é falta de coragem, mas medo disfarçado de controle',
                4: 'Um caminho de percepção para reconhecer padrões antes que virem crises'
            }
        },

        unlockCta: 'Desbloquear o Guia de Chakras',

        turningPoint: {
            title: 'Um dos pontos de virada',
            paragraph1: 'Muitas pessoas passam anos tentando mudar padrões sem compreender onde eles realmente se formam, vivendo em modo automático.',
            paragraph2: 'Mudam de emprego, de cidade, de parceiro, mas levam consigo a mesma forma de se relacionar com medo, com poder, com afeto. Isto porque nunca olharam para a estrutura que sustenta tudo isso.',
            paragraph3: 'Os chakras são, antes de tudo, apenas um mapa de percepção. Um sistema que te ajuda a identificar não só o que você sente, mas por que sente - e em que camada.',
            callout: 'Quando você identifica onde está o excesso, onde existe um bloqueio ou uma compensação, a maneira de lidar com emoções, conflitos e decisões importantes muda naturalmente.'
        },

        darkQuote: {
            text: '"Em um mundo que valoriza velocidade e urgência, talvez o movimento mais transformador seja olhar para aquilo que opera silenciosamente dentro de nós"',
            footer: 'Este guia foi feito exatamente para isso.'
        },

        accessNowLabel: 'Acesse agora',
        accessNowTitle: 'Usuários Premium tem um superdesconto garantido!',
        accessNowTitleNonSubscriber: 'Compreenda seus padrões e inicie sua transformação!',

        premiumBenefits: {
            title: 'Você vai ter acesso ilimitado a:',
            items: {
                0: {
                    title: 'Os 7 chakras explicados com clareza',
                    text: 'Do Muladhara ao Sahasrara, em linguagem acessível'
                },
                1: {
                    title: 'Temas concretos de cada centro energético',
                    text: 'Segurança, vínculos, poder, amor, expressão, intuição, propósito'
                },
                2: {
                    title: 'Sinais de desequilíbrio que talvez você não reconhecia',
                    text: 'Excessos, bloqueios e compensações'
                },
                3: {
                    title: 'Caminhos práticos de ajuste consciente',
                    text: 'Percurso estruturado e respeitoso ao seu ritmo'
                },
                4: {
                    title: 'Uma jornada completa: da base à consciência',
                    text: 'Da segurança até os níveis mais sutis de propósito'
                },
                5: {
                    title: 'Conteúdo atemporal',
                    text: 'Acesse em qualquer dispositivo sempre que quiser'
                }
            }
        },

        payment: {
            launchDiscount: 'DESCONTO ESPECIAL DE LANÇAMENTO',
            from: 'De {fullPrice} por apenas',
            installments: '<span>{installments}x</span><span>{installmentValue}</span>',
            cash: 'sem juros ou à vista: <b>{cashPrice}</b>',
            details: 'Acesso vitalício ⭐ | Liberação imediata 🔑 | Compra segura 🔒',
            installmentsHint: 'Parcele em até {installments}x sem juros'
        },

        paymentButtons: {
            pixWeb: 'PAGAR COM PIX',
            pixApp: 'PAGAR COM PIX',
            creditCard: 'PAGAR COM CARTÃO',
            installments: 'Parcele em até {installments}x sem juros'
        },

        bestDecisionLabel: 'A MELHOR DECISÃO',
        bestDecisionTitle: 'Por que o Guia de Chakras do Astrolink é o melhor para você?',
        bestDecision: {
            items: {
                0: {
                    title: 'Linguagem prática, não abstrata',
                    text: 'Cada chakra conectado a situações reais, sem filosofia inacessível.'
                },
                1: {
                    title: 'Abordagem estruturada e completa',
                    text: 'Temas, sinais de desequilíbrio e caminhos de ajuste para cada chakra.'
                },
                2: {
                    title: 'Honesto sobre o que entrega',
                    text: 'Um instrumento de percepção, sem promessas que não existem.'
                },
                3: {
                    title: 'Integrado à sua jornada no Astrolink',
                    text: 'Complementa o mapa astral e outros conteúdos da plataforma.'
                }
            }
        },

        purchase: {
            text: 'Adquira o Guia de Chakras em uma compra única e acesse sempre que precisar.'
        },

        terms: {
            text: 'Ao continuar, você concorda com nossos',
            link: 'Termos de Uso'
        },

        result: {
            success: {
                title: 'Compra Efetuada!',
                email: 'Você receberá uma confirmação no seu e-mail de cadastro',
                subscribe: {
                    title: 'Seu Cupom de Desconto',
                    discount: 'Assine o Astrolink Premium em qualquer plano com 50% de desconto! Cupom válido por 30 dias',
                    subscribeButton: 'Escolha seu plano',
                    app: {
                        title: 'Torne-se Premium',
                        discount: 'Assine o Astrolink Premium e garanta seu acesso a ferramentas e descontos exclusivos!'
                    }
                },
                guide: {
                    title: 'O Guia de Chakras já está disponível!',
                    message: 'Acesse quando quiser pelo menu <em>Explorar</em>',
                    readButton: 'Leia seu Guia de Chakras'
                }
            },
            error: {
                title: 'Erro ao efetuar a compra 😕',
                message: '<strong>{userName}</strong>, infelizmente ocorreu um erro, pedimos que você verifique as informações inseridas e se o problema persistir, nos contate através do nosso <a href="{supportUrl}">suporte</a>',
                backButton: 'Voltar'
            }
        }
    }
};
